"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ReportMessageModal;
const react_1 = __importStar(require("react"));
require("./MessageExtension.scss");
const MessageExtension_scss_json_1 = __importDefault(require("./MessageExtension.scss.json"));
const Button_1 = require("lincd-mui-base/lib/components/Button");
const Modal_1 = require("lincd-mui-base/lib/components/Modal");
const InputField_1 = require("lincd-input/lib/components/InputField");
const react_select_1 = __importDefault(require("react-select"));
function ReportMessageModal({ getReason, handleReportError, blockUser, onClose, message, deleteAndReportMessage, }) {
    const [blockedUser, setBlockedUser] = (0, react_1.useState)(null);
    const [reasonReported, setReasonReported] = (0, react_1.useState)('');
    const [messageReported, setMessageReported] = (0, react_1.useState)('');
    const [selectedOptions, setSelectedOptions] = (0, react_1.useState)('reportMessage');
    const [messageID, setMessageID] = (0, react_1.useState)(null);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const closeModal = () => {
        setIsModalOpen(false);
        onClose();
    };
    (0, react_1.useEffect)(() => {
        reportModal(message);
    }, []);
    const reportModal = (message) => {
        setBlockedUser(message.getSender());
        setMessageID(message.id);
        getReason(message.text);
        setMessageReported(message.text);
        setIsModalOpen(true);
    };
    const reportMessage = () => __awaiter(this, void 0, void 0, function* () {
        reportModal(message);
        if (blockedUser) {
            yield blockUser(blockedUser);
        }
        else {
            yield deleteAndReportMessage();
        }
    });
    function capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return (react_1.default.createElement(Modal_1.Modal, { isOpen: isModalOpen, onClose: onClose },
        react_1.default.createElement("div", { className: MessageExtension_scss_json_1.default.modal },
            react_1.default.createElement("div", { className: MessageExtension_scss_json_1.default.modalContent },
                react_1.default.createElement("p", { id: MessageExtension_scss_json_1.default.modalTitle }, "Block & Report"),
                react_1.default.createElement("p", { id: MessageExtension_scss_json_1.default.modalDescription }, "Please select what you want to do with this user?"),
                react_1.default.createElement(react_select_1.default, { options: [
                        { value: 'reportUser', label: 'Block User' },
                        { value: 'reportMessage', label: 'Report Message' },
                    ], onChange: (selectedOption) => setSelectedOptions(selectedOption.value) }),
                selectedOptions === 'reportMessage' ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { id: MessageExtension_scss_json_1.default.modalDescriptionText }, "Do you want to report this message? If so please enter reason for the report."),
                    react_1.default.createElement("p", { id: MessageExtension_scss_json_1.default.modalDescriptionText }, "Message being reported:"),
                    react_1.default.createElement(InputField_1.InputField, { type: "text", placeholder: "Reason", value: messageReported, multiline: true, onChange: (e) => setReasonReported(e.target.value) }),
                    react_1.default.createElement("p", { id: MessageExtension_scss_json_1.default.modalDescriptionText }, "Reason:"),
                    react_1.default.createElement(InputField_1.InputField, { className: MessageExtension_scss_json_1.default.reportedInput, type: "text", placeholder: "Reason", value: reasonReported, multiline: true, onChange: (e) => setReasonReported(e.target.value) }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { id: MessageExtension_scss_json_1.default.modalDescriptionText },
                        "Do you want to block ",
                        capitalize(blockedUser.name),
                        "?"))),
                react_1.default.createElement("div", { className: MessageExtension_scss_json_1.default.reportUserPopup },
                    react_1.default.createElement(Button_1.Button, { onClick: closeModal }, "Cancel"),
                    react_1.default.createElement(Button_1.Button, { onClick: reportMessage }, selectedOptions === 'reportMessage' ? 'Report' : 'Block'))))));
}
//# sourceMappingURL=MessageExtension.js.map